import produce from "immer";
import { IStoreState } from "../../initialStoreState";
import { LoadState } from "../../../constants/enums";
import { CalAgencyBillorDirectActions } from ".";
import { initialCalAgencyBillorDirectBillState } from "./AccountingReports.types";
import {
  CHANGE_BALANCE_WAIVER_RUNNING_BALANCE,
  CLEAR_SALES_SUMMARY_STATE,
  FETCH_ACCOUNT_PAYABLE_LIST_FAILURE,
  FETCH_ACCOUNT_PAYABLE_LIST_PROGRESS,
  FETCH_ACCOUNT_PAYABLE_LIST_SUCCESS,
  FETCH_AGED_INSURER_PAYABLES_LIST_FAILURE,
  FETCH_AGED_INSURER_PAYABLES_LIST_PROGRESS,
  FETCH_AGED_INSURER_PAYABLES_LIST_SUCCESS,
  FETCH_INSURANCE_REMMITTANCE_LIST_FAILURE,
  FETCH_INSURANCE_REMMITTANCE_LIST_PROGRESS,
  FETCH_INSURANCE_REMMITTANCE_LIST_SUCCESS,
  FETCH_RECEIVABLE_DETAILED_REPORT_LIST_FAILURE,
  FETCH_RECEIVABLE_DETAILED_REPORT_LIST_PROGRESS,
  FETCH_RECEIVABLE_DETAILED_REPORT_LIST_SUCCESS,
  FETCH_RECEIVABLE_REPORT_LIST_FAILURE,
  FETCH_RECEIVABLE_REPORT_LIST_PROGRESS,
  FETCH_RECEIVABLE_REPORT_LIST_SUCCESS,
  FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_FAILURE,
  FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_PROGRESS,
  FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_SUCCESS,
  FETCH_SALES_COMMISSION_DETAILED_LIST_FAILURE,
  FETCH_SALES_COMMISSION_DETAILED_LIST_PROGRESS,
  FETCH_SALES_COMMISSION_DETAILED_LIST_SUCCESS,
  FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_FAILURE,
  FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_PROGRESS,
  FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_SUCCESS,
  FETCH_SALES_COMMISSION_SUMMARY_LIST_FAILURE,
  FETCH_SALES_COMMISSION_SUMMARY_LIST_PROGRESS,
  FETCH_SALES_COMMISSION_SUMMARY_LIST_SUCCESS,
  FETCH_TAX_REPORT_LIST_FAILURE,
  FETCH_TAX_REPORT_LIST_PROGRESS,
  FETCH_TAX_REPORT_LIST_SUCCESS,
} from "./AccountingReportsActions";

export const CallAgencyBillorDirectReducer = (
  state: IStoreState["accounting"]["accountingReports"] = initialCalAgencyBillorDirectBillState,
  action: CalAgencyBillorDirectActions
) => {
  switch (action.type) {
    case FETCH_SALES_COMMISSION_SUMMARY_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_summary.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_SALES_COMMISSION_SUMMARY_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_summary.loading = LoadState.Loaded;
        draftState.sales_commission_summary.list = list;
      });
      return newState;
    }

    case FETCH_SALES_COMMISSION_SUMMARY_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_summary.loading = LoadState.Failed;
      });
      return newState;
    }


    case FETCH_SALES_COMMISSION_DETAILED_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_detailed.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_SALES_COMMISSION_DETAILED_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_detailed.loading = LoadState.Loaded;
        draftState.sales_commission_detailed.list = list;
      });
      return newState;
    }

    case FETCH_SALES_COMMISSION_DETAILED_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_detailed.loading = LoadState.Failed;
      });
      return newState;
    }
    case FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_detailed_breakdown.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        console.log("breakdown list", list);
        draftState.sales_commission_detailed_breakdown.loading = LoadState.Loaded;
        draftState.sales_commission_detailed_breakdown.list = list;
      });
      return newState;
    }

    case FETCH_SALES_COMMISSION_DETAILED_BREAKDOWN_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_detailed_breakdown.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_RECEIVABLE_REPORT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.receivable_summary.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_RECEIVABLE_REPORT_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.receivable_summary.loading = LoadState.Loaded;
        draftState.receivable_summary.list = list;
      });
      return newState;
    }

    case FETCH_RECEIVABLE_REPORT_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.receivable_summary.loading = LoadState.Failed;
      });
      return newState;
    }

    case CHANGE_BALANCE_WAIVER_RUNNING_BALANCE: {
      const { index, runningBalance } = action.payload;
      const newState = produce(state, (draftState) => {
       
        if (index !== -1) {
          draftState.receivable_summary.list[index].running_balance = runningBalance;
        }
      });
      return newState;
    }

    case FETCH_RECEIVABLE_DETAILED_REPORT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.receivable_detailed.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_RECEIVABLE_DETAILED_REPORT_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.receivable_detailed.loading = LoadState.Loaded;
        draftState.receivable_detailed.list = list;
      });
      return newState;
    }

    case FETCH_RECEIVABLE_DETAILED_REPORT_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.receivable_detailed.loading = LoadState.Failed;
      });
      return newState;
    }


    case FETCH_TAX_REPORT_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.tax.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_TAX_REPORT_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.tax.loading = LoadState.Loaded;
        draftState.tax.list = list;
      });
      return newState;
    }

    case FETCH_TAX_REPORT_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.tax.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_ACCOUNT_PAYABLE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.account_payable.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_ACCOUNT_PAYABLE_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.account_payable.loading = LoadState.Loaded;
        draftState.account_payable.list = list;
      });
      return newState;
    }

    case FETCH_ACCOUNT_PAYABLE_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.account_payable.loading = LoadState.Failed;
      });
      return newState;
    }


     case FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_summary_by_type.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_summary_by_type.loading = LoadState.Loaded;
        draftState.sales_commission_summary_by_type.list = list;
      });
      return newState;
    }

    case FETCH_SALES_COMMISSION_SUMMARY_BY_TYPE_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.sales_commission_summary_by_type.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_INSURANCE_REMMITTANCE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.insurance_remittance.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_INSURANCE_REMMITTANCE_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.insurance_remittance.loading = LoadState.Loaded;
        draftState.insurance_remittance.list = list;
      });
      return newState;
    }

    case FETCH_INSURANCE_REMMITTANCE_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.insurance_remittance.loading = LoadState.Failed;
      });
      return newState;
    }

    case FETCH_AGED_INSURER_PAYABLES_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.aged_insurer_payables.loading = LoadState.InProgress;
      });
      return newState;
    }

    case FETCH_AGED_INSURER_PAYABLES_LIST_SUCCESS: {
      const { list } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.aged_insurer_payables.loading = LoadState.Loaded;
        draftState.aged_insurer_payables.list = list;
      });
      return newState;
    }

    case FETCH_AGED_INSURER_PAYABLES_LIST_FAILURE: {
      const newState = produce(state, (draftState) => {
        draftState.aged_insurer_payables.loading = LoadState.Failed;
      });
      return newState;
    }

    case CLEAR_SALES_SUMMARY_STATE: {
      return initialCalAgencyBillorDirectBillState;
    }

    default:
      return state;
  }
};
